var map = {
	"./icon_change.svg": "789e",
	"./icon_class.svg": "e834",
	"./icon_close.svg": "a519",
	"./icon_courseware.svg": "fd5f",
	"./icon_error.svg": "8e5e",
	"./icon_info.svg": "eaa1",
	"./icon_mission.svg": "9842",
	"./icon_more.svg": "14c5",
	"./icon_play.svg": "7130",
	"./icon_reset.svg": "4a1c",
	"./icon_right.svg": "17487",
	"./icon_search.svg": "7bdf",
	"./icon_share.svg": "8f84",
	"./icon_success.svg": "0c14",
	"./icon_tips.svg": "3c01",
	"./icon_video.svg": "a33f",
	"./icon_warning.svg": "18f2",
	"./no_works.svg": "8754"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";